import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: "01",
  title: "RECUPERA TU CALMA",
  desc: "Identificamos qué está generando mayor carga emocional y comenzamos a trabajar herramientas prácticas para recuperar claridad."
}, {
  num: "02",
  title: "VUELVE A TI",
  desc: "Trabajamos autoestima, dependencia emocional, pensamientos repetitivos, límites y conexión contigo mismo."
}, {
  num: "03",
  title: "RECONSTRUYE TU VIDA",
  desc: "Comenzamos a ordenar hábitos, relaciones, proyectos, propósito y decisiones."
}, {
  num: "04",
  title: "CREA TU NUEVO PUNTO DE PARTIDA",
  desc: "Diseñamos un plan de acción para continuar avanzando después de los 30 días."
}];
export function Method() {
  return <section className="py-24 md:py-32 bg-ink-light relative border-y border-white/5" id="metodo" data-id="element-238" data-mp="3u9eemm7skspj">
      <div className="container mx-auto px-6" data-id="element-239" data-mp="2wqcwejsqfo57">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-240" data-mp="31q8s7vra099o">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-241" data-mp="pfeounke5rhe">
            <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-4 uppercase tracking-wide" data-id="element-242" data-mp="fpd4o6v5st7r">
              EL MÉTODO RECUPERA TU VIDA
            </h2>
            <p className="text-gold text-lg md:text-xl font-serif italic" data-id="element-243" data-mp="blx798b9mou0">
              4 etapas para reconstruirte desde adentro.
            </p>
          </motion.div>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-244" data-mp="1o94bv3iab0r">
          <div className="space-y-12 relative" data-id="element-245" data-mp="3svv9xt9scnk9">
            {/* Vertical Line */}
            <div className="absolute left-[1.35rem] md:left-1/2 top-4 bottom-4 w-[1px] bg-white/10 md:-translate-x-1/2 hidden sm:block" data-id="element-246" data-mp="3sxy8j1p07p0l"></div>

            {steps.map((step, index) => <motion.div key={step.num} className={`flex flex-col sm:flex-row gap-6 md:gap-12 relative ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.15
          }} data-id="element-247" data-mp="1r2nv0ky347yw" data-mpi={index}>
                {/* Number Node */}
                <div className="absolute left-0 md:left-1/2 top-0 w-12 h-12 rounded-full bg-ink border border-gold flex items-center justify-center text-gold font-serif text-lg md:-translate-x-1/2 z-10 shadow-[0_0_15px_rgba(201,163,106,0.2)]" data-id="element-248" data-mp="3bm18kvg42il9">
                  {step.num}
                </div>

                {/* Content */}
                <div className={`sm:w-1/2 pl-16 sm:pl-0 pt-2 ${index % 2 === 0 ? 'md:text-left md:pr-16' : 'md:text-right md:pl-16'}`} data-id="element-249" data-mp="3qb70dycmd6j4">
                  <span className="text-gold text-xs tracking-[0.2em] font-semibold uppercase mb-2 block" data-id="element-250" data-mp="2ewjsrnnezg5u">
                    Etapa {step.num}
                  </span>
                  <h3 className="text-2xl font-serif text-ivory-bright mb-3" data-id="element-251" data-mp="2jwy2rb8kt06i">{step.title}</h3>
                  <p className="text-muted font-light leading-relaxed" data-id="element-252" data-mp="2bd1iclel93we">{step.desc}</p>
                </div>
                
                {/* Empty space for alternating layout */}
                <div className="hidden sm:block sm:w-1/2" data-id="element-253" data-mp="2lbh92n9peb5d"></div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}